export { default } from "./BadgeDiscount.jsx";
